import { useState, useEffect } from "react";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import facts from "@/data/common/facts.json";
import { getRandomIndex } from "@/utils/arrays";
import Lottie from "react-lottie";
import animationData from "@/assets/lottie/travel.json";

interface Props {
  loaderSize?: "sm" | "md" | "lg";
}

const LottieLoader = () => {
  const [quoteIndex, setQuoteIndex] = useState(getRandomIndex(facts.length));

  useEffect(() => {
    const quoteInterval = setInterval(() => {
      setQuoteIndex(getRandomIndex(facts.length));
    }, 5000);

    return () => {
      clearInterval(quoteInterval);
    };
  }, []);

  return (
    <Stack
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* <LinearProgress size={loaderSize} /> */}
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData: animationData,
          rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
          },
        }}
        height={200}
        width={200}
      />
      <Typography
        component={"p"}
        sx={{
          color: "neutral.500",
          m: 2,
        }}
      >
        {facts[quoteIndex].fact}
      </Typography>
      <Typography
        component={"p"}
        sx={{
          color: "neutral.500",
          m: 2,
          textAlign: "center",
          fontStyle: "italic",
        }}
      >
        - {facts[quoteIndex].name}
      </Typography>
    </Stack>
  );
};

export default LottieLoader;
